export const newsOrder = 'created,desc;';
